"use client";
import React from "react";
import logo from "../assets/images/logo.svg"

const Loading = () => {

  return (
    <div className="loader__wrapper">
      <img src={logo} alt="لوگوی پاکشوما" className="logo" priority={true} layout="intrinsic"  loading="lazy"/>
      <div>
        <div className="main-loader"></div>
      </div>
    </div>
  );
};

export default Loading;
